export default {
  imgResize: async function (file) {
    return new Promise(async (resolve, reject) => {
      const image = document.createElement('img')
      image.src = URL.createObjectURL(file)
      // 이미지가 로드되면 canvas를 원하는 크기로 만들고 이미지를 그에 맞춰 그립니다.
      image.onload = () => {
        URL.revokeObjectURL(image.src)
        let canvas = document.createElement('canvas')

        let MAX_WIDTH = 400
        let MAX_HEIGHT = 400
        let width = image.width
        let height = image.height

        if (width > height) {
          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width
            width = MAX_WIDTH
          }
        } else {
          if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height
            height = MAX_HEIGHT
          }
        }
        canvas.width = width
        canvas.height = height
        let ctx = canvas.getContext('2d')
        ctx.drawImage(image, 0, 0, width, height)
        // canvas에 그려진 이미지를 Blob으로 만들고 다시 File로 만들어 배열에 저장합니다.
        let dataURI = canvas.toDataURL('image/png') // png => jpg 등으로 변환 가능
        let byteString = atob(dataURI.split(',')[1])
        let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
        let ab = new ArrayBuffer(byteString.length)
        let ia = new Uint8Array(ab)
        for (var i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i)
        }

        let bb = new Blob([ab], { 'type': mimeString })
        resolve(bb)
      }
    })
  },
  setUnpackedAreas: function (areaArr) {
    let result = areaArr.filter(items => items != null)
    let allList = result.filter(items => items < 0)
    if (allList.length !== 0) {
      // 전체값 있음
      for (var i = 0; i < allList.length; i++) {
        let regionName = window.store.getters.getRegionList.find(items => items.id === (allList[i] * -1)).name
        let districtList = window.store.getters.getDistrictAllList.filter(items => items.regionName === regionName)

        let idx = result.indexOf(allList[i])
        if (idx > -1) {
          result.splice(idx, 1)
        }
        for (var j = 0; j < districtList.length; j++) {
          result.push(districtList[j].id)
        }
      }
    }
    // 중복값 제거
    let removedDuplicate = result.filter(function (item, pos) {
      return result.indexOf(item) === pos
    })

    return removedDuplicate
  },
  setPackedAreas: function (areaArr) {
    let formattedAreaArr = []
    let districtList = window.store.getters.getDistrictAllList
    let regionList = window.store.getters.getRegionList
    if (areaArr.length >= 5 && areaArr.filter(arr => arr < 0).length === 0 && areaArr.filter(arr => arr == null).length === 0) {
      // 배열 sort
      areaArr.sort(function (a, b) { // 오름차순
        return a - b
      })
      // 기존에 EnrollState에 지정된 구역이 있고 5개 이상일땐 전체가능성 있음 --> format필요
      // 전체 구역 목록을 불러옴
      let count = 0
      // 같은 지역 설정 및 같은지역 목록 셋팅
      let regionName = districtList.find(items => items.id === areaArr[0]).regionName
      let regionId = regionList.find(items => items.name === regionName).id
      let sameRegionDistrict = [...new Set(districtList.filter(items => items.regionName === regionName).map(items => items.id))]
      for (var i = 0; i < areaArr.length; i++) {
        formattedAreaArr.push(areaArr[i])
        if (sameRegionDistrict.includes(areaArr[i])) {
          // 현재 설정된 지역의 데이터 일 시
          // 같은 지역 갯수 카운터 증가
          count++
          if (sameRegionDistrict.length === count) {
            // 같은 지역 구역의 데이터의 갯수와 카운터가 같을 경우 전체지역으로 판단
            // formattedAreaArr에 해당 지역 데이터 삭제
            formattedAreaArr = formattedAreaArr.filter(function (el) {
              return !sameRegionDistrict.includes(el)
            })
            // 전체목록 데이터 1개 푸쉬
            formattedAreaArr.push(regionId * -1)
          }
        } else {
          // 현재 설정된 지역의 데이터가 아닐 시
          // 새 지역설정 및 새 같은지역 목록 셋팅
          regionName = districtList.find(items => items.id === areaArr[i]).regionName
          regionId = regionList.find(items => items.name === regionName).id
          sameRegionDistrict = [...new Set(districtList.filter(items => items.regionName === regionName).map(items => items.id))]
          count = 1
        }
      }
    } else {
      formattedAreaArr = areaArr
    }

    return formattedAreaArr
  },
  setUnpackedAges: function (ageArr) {
    if(ageArr.includes(-1)) {
      return [0, 1, 2, 3, 4, 5]
    }else{
      return ageArr
    }
  },
  setUnpackedJobs: function (jobArr) {
    if(jobArr.includes(-1)) {
      return [0, 1, 2, 3, 4, 5, 6, 7, 8]
    }else{
      return jobArr
    }
  },
  enrollValidCheck: function (errorCode) {
    /**
     * ERROR_CODE
     * ok: 0
     * invalidCouponText: 1
     * invalidPollidePoint: 2
     * answerCount < 2: 4
     * startDate < tomorrow: 5
     * startDate > endDate: 6
     * invalidCouponExpiredDate: 7
     * notnull(titleText): 8
     // * notnull(titleImg): 9
     * notnull(category): 10
     * notnull(toward): 11
     * notnull(gender): 12
     * notnull(job): 13
     * notnull(age): 14
     * notnull(area): 15
     * notnull(reward): 16
     * notnull(totalBudget): 17
     * notnull(answerText): 18
     * totalBudget > availableAdPoint: 19
     * dailyBudget < rewardPoint: 20
     */

    switch (errorCode) {
      case 1:
        return '쿠폰 제목을 입력해주세요.'
      case 2:
        return '포인트 값을 입력해주세요.'
      case 3:
        return '답변제목과 답변이미지 중 미입력된 부분이 있습니다.' // 미사용
      case 4:
        return '답변은 최소 2개 이상이어야 합니다.'
      case 5:
        return '광고 시작일은 내일부터 지정할 수 있습니다.'
      case 6:
        return '광고 시작일과 광고 종료일을 확인해주세요.'
      case 7:
        return '쿠폰 마감일을 확인해주세요.'
      case 8:
        return '제목을 입력해 주세요.'
      case 9:
        return '제목이미지를 선택해 주세요.'
      case 10:
        return '카테고리를 선택해 주세요.'
      case 11:
        return '광고 대상을 선택해 주세요'
      case 12:
        return '성별을 선택해 주세요'
      case 13:
        return '직업을 선택해 주세요'
      case 14:
        return '연령대를 선택해 주세요'
      case 15:
        return '지역을 선택해 주세요'
      case 16:
        return '보상방식을 선택해 주세요'
      case 17:
        return '예산을 선택해 주세요'
      case 18:
        return '답변 제목을 입력해 주세요'
      case 19:
        return '지출될 광고비가 사용가능 포인트를 초과합니다.|포인트를 충전하거나 광고비를 조정해주세요.|* 사용가능 포인트: 보유포인트 ─ 게시(예정)된 광고의 사용 포인트'
      case 20:
        return '지출될 광고비가 너무 적습니다.|광고비를 조정해주세요.'
      default:
        return '확인되지 않은 오류입니다.'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/utils.js